import { computed, ref, ComputedRef } from 'vue'
import { useApi } from '@/composables/useApi'

export type AdviceStatus = {
    [key: string]: string | number
    id: number
    symbol: string
    name: string
}

const isLoading = ref<boolean>(false)
const adviceStatuses = ref<AdviceStatus[]>([])
const isEmpty = computed(() => adviceStatuses.value.length === 0)

export const useAdviceStatuses = (): {
    fetchAdviceStatuses: () => Promise<void>
    adviceStatuses: ComputedRef<AdviceStatus[]>
    isLoading: ComputedRef<boolean>
    isEmpty: ComputedRef<boolean>
} => {
    const { useGet } = useApi()

    async function fetchAdviceStatuses(): Promise<void> {
        if (!isEmpty.value) return

        isLoading.value = true
        try {
            const { status, data } = await useGet('/advice-statuses')
            if (status === 200 && data.data) {
                adviceStatuses.value = data.data
            }
        } finally {
            isLoading.value = false
        }
    }

    return {
        fetchAdviceStatuses,
        adviceStatuses: computed(() => adviceStatuses.value),
        isLoading: computed(() => isLoading.value),
        isEmpty,
    }
}
